<tg-row class="summary-page-property-information-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Property information</p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-page-property-information-section__header--right"
    >
        <a
            routerLink="../{{ stepIds.propertyInformation }}"
            routerLinkActive="active"
            class="h-link-no-visited"
            >Edit property information</a
        >
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Category:</span
        >
        {{ category }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Address:</span
        >
        {{ address }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Land area (m<sup>2</sup>):</span
        >
        {{ landArea }}
    </tg-col>
</tg-row>
